'use client';

import { Box, Image, Link } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import Interpolate from 'components/Interpolate/Interpolate';
import { useLocale } from 'next-intl';
import css from './common.module.css';
function PlatformLinks() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'downloads');
  return <Interpolate t={t} i18nKey="downloadTodoist" mapping={{
    linuxLink: <Link href="/downloads/linux" />,
    macLink: <Link href="/downloads/mac" />,
    windowsLink: <Link href="/downloads/windows" />,
    iosLink: <Link href="/downloads/ios" />,
    ipadLink: <Link href="/downloads/ipad" />,
    androidLink: <Link href="/downloads/android" />,
    appleWatchLink: <Link href="/downloads/applewatch" />,
    wearOSLink: <Link href="/downloads/wearos" />,
    browserLink: <Link href="/integrations?category=browsers" />,
    emailLink: <Link href="/integrations?category=email" />
  }} data-sentry-element="Interpolate" data-sentry-component="PlatformLinks" data-sentry-source-file="common.tsx" />;
}
function HeroIllustration() {
  return <Box className={css.imageWrapper} data-sentry-element="Box" data-sentry-component="HeroIllustration" data-sentry-source-file="common.tsx">
            <Image src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/downloads/header-illustration.png`} width={802} height={300} alt="" data-sentry-element="Image" data-sentry-source-file="common.tsx" />
        </Box>;
}
export { HeroIllustration, PlatformLinks };